import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environmentConfig } from '../../environment';
import { Observable, throwError, catchError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SMCService {
  private apiUrl = environmentConfig.apiBaseUrl;
  constructor(private http: HttpClient) {}
  private fetchAuthenticated(
      url: string,
      method: 'GET' | 'POST' | 'PUT',
      token: string,
      bodyData?: any
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    });
    const httpOptions = { headers };
    let httpCall: Observable<any>;
    if (method === 'GET') {
      httpCall = this.http.get(url, httpOptions);
    } else if (method === 'POST') {
      httpCall = this.http.post(url, bodyData, httpOptions);
    } else if (method === 'PUT') {
      httpCall = this.http.put(url, bodyData, httpOptions);
    } else {
      return throwError(() => new Error('Unsupported method'));
    }
    return httpCall.pipe(
      catchError(error => {
        console.error('❌ HTTP Error:', error);
        return throwError(() => error);
      })
    );
  }

  getInbox(userid: number, token: string): Promise<any> {
    const url = `${this.apiUrl}/api/smc/getinbox?userid=${userid}`;
    return this.fetchAuthenticated(url, 'POST', token, null).toPromise();
  }

  saveMessage(userid: number, json: object | null, token: string): Promise<any> {
    console.log("saveMessage payload >> ",json)
    const url = `${this.apiUrl}/api/smc/savemsg?userid=${userid}`;
    return this.fetchAuthenticated(url, 'POST', token, json).toPromise();
  }

}

